import React, { useEffect, useState } from "react";
import AdminLayout from "../../components/admin/AdminLayout";
import { servicesApi } from "../../services/api";

function CorporateTrainingSettings() {
  const [formData, setFormData] = useState({
    programs_title: "Sample Training Programs",
    programs_subtitle: "",
    benefits_title: "Why Choose Innobig for Corporate Training",
    benefits_subtitle: "",
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await servicesApi.getCorporateTrainingSections();
      setFormData({
        programs_title:
          response?.data?.programs_title || "Sample Training Programs",
        programs_subtitle: response?.data?.programs_subtitle || "",
        benefits_title:
          response?.data?.benefits_title ||
          "Why Choose Innobig for Corporate Training",
        benefits_subtitle: response?.data?.benefits_subtitle || "",
      });
    } catch (error) {
      console.error("Error loading corporate training settings:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await servicesApi.updateCorporateTrainingSections(formData);
      alert("Corporate training section updated successfully!");
    } catch (error) {
      console.error("Error saving corporate training settings:", error);
      alert("Failed to update section. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <div className="text-center py-8">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-600"></div>
          <p className="mt-4 text-gray-600">Loading settings...</p>
        </div>
      </AdminLayout>
    );
  }

  return (
      <div className="max-w-3xl">
        <div className="bg-white rounded-lg shadow p-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-6">
            Corporate Training Settings
          </h1>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-4">
              <h2 className="text-lg font-semibold">Why Choose Us</h2>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Title
                </label>
                <input
                  type="text"
                  name="benefits_title"
                  value={formData.benefits_title}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Subtitle
                </label>
                <textarea
                  name="benefits_subtitle"
                  value={formData.benefits_subtitle}
                  onChange={handleChange}
                  rows="3"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Sample Training Programs Title
              </label>
              <input
                type="text"
                name="programs_title"
                value={formData.programs_title}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Sample Training Programs Subtitle
              </label>
              <textarea
                name="programs_subtitle"
                value={formData.programs_subtitle}
                onChange={handleChange}
                rows="3"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              />
            </div>

            <div className="pt-6 border-t">
              <button
                type="submit"
                disabled={saving}
                className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 disabled:opacity-50"
              >
                {saving ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </form>
        </div>
      </div>
  );
}

export default CorporateTrainingSettings;
